export default () => {
  $(document).on('click', '.hero-banner [data-scroll-to-next-section]', (e) => {
    const $item = $(e.currentTarget);

    $('html, body').animate({ scrollTop: $item.offset().top + $item.outerHeight(true) - 50 }, 'slow');
  });
};
